import axios, { type AxiosInstance } from 'axios';
import { DEFAULT_CLIENT_CONFIG, type ApiClientConfig } from './types';
import { applyInterceptors } from './interceptors';

export function createApiClient(config?: Partial<ApiClientConfig>): AxiosInstance {
  const merged: ApiClientConfig = { ...DEFAULT_CLIENT_CONFIG, ...config };

  const client: AxiosInstance = axios.create({
    baseURL: merged.baseURL,
    timeout: merged.timeout,
    headers: { 'Content-Type': 'application/json' },
  });

  applyInterceptors(client, merged.enableLogging);

  return client;
}
